import axios from "axios";
import AuthService from "../services/auth.service";

// const API_URL = "http://localhost:8000/"

const API_URL =
  process.env.NODE_ENV !== "production"
    ? "https://sbg.ingenioushitech.com/"
    : "https://sbg.ingenioushitech.com/";

const SB_API_URL = "https://security-base-group-api-b7pp.onrender.com/";

// axios.interceptors.request.use(function (config) {
//   const token = AuthService.getCurrentUserTokken();
//   if (token) {
//     config.headers.Authorization = "Bearer " + token;
//   }
//   return config;
// });

axios.interceptors.request.use(function (config) {
  const token = AuthService.getCurrentUserTokken();
  const sbToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7Il9pZCI6IjY3YjcwYTUyNmM0ZjE0ZDg3N2Q5NjdkMCIsIm5hbWUiOiJTZWN1cml0eSBCYXNlIEdyb3VwIiwiZW1haWwiOiJzYWxlc0BzZWN1cml0eWJhc2Vncm91cC5jb20iLCJwYXNzd29yZCI6IiQyYiQxMCRlNEY2bkswTDM4bnQ2b1VycEMuU2VPZ2ZPemNLa0hBNTZtUUwwRDFxbXRVUjdkWjF0WHdLbSIsInBob25lTm8iOiIxMjM0NTY3ODkwIiwiY3JlYXRlZEF0IjoiMjAyNS0wMi0yMFQxMDo1NjoxOC4zNzVaIiwidXBkYXRlZEF0IjoiMjAyNS0wNS0wMVQxMTo1Nzo1MS45MzlaIiwiX192IjowfSwiaWF0IjoxNzY4MjE0MTg3fQ.lxQsNIrzNnQcii1CEFnDYmxST_XXf9iGL-1BqsEhqec";

  if (config.url.startsWith(SB_API_URL)) {
    config.headers.Authorization = "Bearer " + sbToken;
  } else if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("tUser");
      localStorage.removeItem("tUserId");
      localStorage.removeItem("tToken");
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

const getToolDetails = () => {
  return axios.get(API_URL + "api/tool/getAll");
};
const addNewTool = (data) => {
  return axios.post(API_URL + "api/tool/add", data);
};
const deleteTool = (id) => {
  return axios.delete(API_URL + `api/tool/delete/${id}`);
};
const updateTool = (id, data) => {
  return axios.put(API_URL + "api/tool/update/" + id, data);
};
const getOfficersById = (id) => {
  return axios.get(API_URL + "api/officer/get/" + id);
};
const updateOfficerById = (id, data) => {
  return axios.put(API_URL + "api/officer/update/" + id, data);
};

// Industry CRM API
const getAllContacts = (params) => {
  return axios.get(API_URL + "api/contact/getAll", { params });
};
const getContactById = (id) => {
  return axios.get(API_URL + `api/contact/get/${id}`);
};
const addContact = (data) => {
  return axios.post(API_URL + "api/contact/add", data);
};
const updateContact = (id, data) => {
  return axios.put(API_URL + `api/contact/update/${id}`, data);
};
const deleteContact = (id) => {
  return axios.delete(API_URL + `api/contact/delete/${id}`);
};

// securityBasePanel APIs
const getProfile = () => axios.get(SB_API_URL + "api/admin/get");
const getContactForm = () => axios.get(SB_API_URL + "api/contact/getAll");
const getContactFormById = (id) =>
  axios.get(SB_API_URL + "api/contact/get/" + id);
const createContactFormEntry = (data) =>
  axios.post(SB_API_URL + "api/contact/create", data);
const updateContactForm = (id, data) =>
  axios.put(SB_API_URL + "api/contact/update/" + id, data);
const deleteContactForm = (id) =>
  axios.delete(SB_API_URL + "api/contact/delete/" + id);
const getNotifications = () =>
  axios.get(SB_API_URL + "api/admin/get-notifications");
const updateNotification = (id, data) =>
  axios.put(SB_API_URL + "api/admin/update-notification/" + id, data);
const getContractors = () => axios.get(SB_API_URL + "api/contractor/getAll");
const getContractorById = (id) =>
  axios.get(SB_API_URL + "api/contractor/get/" + id);
const createContractor = (data) =>
  axios.post(SB_API_URL + "api/contractor/create", data);
const updateContractor = (id, data) =>
  axios.put(SB_API_URL + "api/contractor/update/" + id, data);
const deleteContractor = (id) =>
  axios.delete(SB_API_URL + "api/contractor/delete/" + id);
const emailSend = (data) => axios.post(SB_API_URL + "api/mail/send", data);
const addComment = (data) => axios.post(SB_API_URL + "api/comment/add", data);

const submitApplication = (formData) => {
  return axios.post(API_URL + "api/security-guard/create", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const getAll = (params = {}) => {
  return axios.get(API_URL + "api/security-guard/getAll", { params });
};

const getById = (id) => {
  return axios.get(API_URL + `api/security-guard/get/${id}`);
};

const update = (id, formData) => {
  return axios.put(API_URL + `api/security-guard/update/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const remove = (id) => {
  return axios.delete(API_URL + `api/security-guard/delete/${id}`);
};

const updateStatus = (id, data) => {
  return axios.put(API_URL + `api/security-guard/status/${id}`, data);
};

const DataService = {
  addNewTool,
  deleteTool,
  updateTool,
  getToolDetails,
  getOfficersById,
  updateOfficerById,
  getAllContacts,
  getContactById,
  addContact,
  updateContact,
  deleteContact,
  // securityBasePanel
  getProfile,
  getContactForm,
  getContactFormById,
  createContactFormEntry,
  updateContactForm,
  deleteContactForm,
  getNotifications,
  updateNotification,
  getContractors,
  getContractorById,
  createContractor,
  updateContractor,
  deleteContractor,
  emailSend,
  addComment,
  submitApplication,
  getAll,
  getById,
  update,
  remove,
  updateStatus,
  // Insurance APIs
  addInsurance: (data) => axios.post(API_URL + "api/insurance/add", data),
  getInsurances: () => axios.get(API_URL + "api/insurance/getAll"),
  deleteInsurance: (id) => axios.delete(API_URL + `api/insurance/delete/${id}`),
  updateInsurance: (id, data) =>
    axios.put(API_URL + `api/insurance/update/${id}`, data),
  // Subscription APIs
  addSubscription: (data) => axios.post(API_URL + "api/subscription/add", data),
  getSubscriptions: () => axios.get(API_URL + "api/subscription/getAll"),
  deleteSubscription: (id) =>
    axios.delete(API_URL + `api/subscription/delete/${id}`),
  updateSubscription: (id, data) =>
    axios.put(API_URL + `api/subscription/update/${id}`, data),
  // License APIs
  addLicense: (data) => axios.post(API_URL + "api/license/add", data),
  getLicenses: () => axios.get(API_URL + "api/license/getAll"),
  deleteLicense: (id) => axios.delete(API_URL + `api/license/delete/${id}`),
  updateLicense: (id, data) =>
    axios.put(API_URL + `api/license/update/${id}`, data),
};

export default DataService;
